import { render, staticRenderFns } from "./MemberWealth.vue?vue&type=template&id=37bb83fe&scoped=true"
import script from "./MemberWealth.vue?vue&type=script&lang=js"
export * from "./MemberWealth.vue?vue&type=script&lang=js"
import style0 from "./MemberWealth.vue?vue&type=style&index=0&id=37bb83fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bb83fe",
  null
  
)

export default component.exports